// @flow
import { useContext } from 'react';

import {
  CC_STARTER_COMMIT_LAUNCH,
  CC_STARTER_COMMIT_LAUNCH_PRO,
  CC_STARTER_COMMIT_TYPE_BACKEND_NAME,
} from '../constants';
import { EstimateContext } from '../contexts/EstimateContext';

export const useIsCCStarterCommitSelected = () => {
  const estimate = useContext(EstimateContext);

  return [CC_STARTER_COMMIT_LAUNCH, CC_STARTER_COMMIT_LAUNCH_PRO].includes(
    estimate?.inputs?.[CC_STARTER_COMMIT_TYPE_BACKEND_NAME]
  );
};
